import * as React from "react";
import { orderBy } from "lodash";
import { JSX } from "react";
import RoleModel from "@app/user/roleModel";
import { ClientService } from "@app/client/clientService";

export interface ClientDefaultProps {
  // initializer
  initialize: () => void;

  // state getters
  availableRoles: RoleModel[];
  defaultRoles: RoleModel[];
  loading: boolean;

  //state setters
  setDefaultRoles: React.Dispatch<React.SetStateAction<RoleModel[]>>;
}

type ClientDefaultProviderProps = { children: React.ReactNode };

export const ClientDefaultContext = React.createContext<Partial<ClientDefaultProps>>({});

export function ClientDefaultProvider(props: ClientDefaultProviderProps): JSX.Element {
  const [availableRoles, setAvailableRoles] = React.useState<RoleModel[]>([]);
  const [defaultRoles, setDefaultRoles] = React.useState<RoleModel[]>([]);
  const [loading, setLoading] = React.useState(true);

  const clientService = new ClientService();

  React.useEffect(() => {
    loadFromService();
  }, []);

  const loadFromService = async () => {
    const availables = await clientService.getAvailableDefaultRoles();
    const defaults = (await clientService.getDefaultRoles()).map((role) => {
      const matchedRoleModel = availables.find((r) => r.name === role.name);
      return matchedRoleModel;
    }).filter((r) => !!r);

    setAvailableRoles(orderBy(availables, (r) => r.name, "asc"));
    setDefaultRoles(orderBy(defaults, (r) => r.name, "asc"));

    setLoading(false);
  };

  return (
    <ClientDefaultContext.Provider
      value={{
        availableRoles,
        defaultRoles,
        loading,
        setDefaultRoles,
      }}
    >
      {props.children}
  </ClientDefaultContext.Provider>
  );
}